'use strict';

var hashes = require('jshashes'),
    xtend = require('xtend'),
    sha1 = new hashes.SHA1();

var ohauth = {};

ohauth.qsString = function (obj) {
  return Object.keys(obj).sort().map(function (key) {
    return ohauth.percentEncode(key) + '=' + ohauth.percentEncode(obj[key]);
  }).join('&');
};

ohauth.stringQs = function (str) {
  return str.split('&').filter(function (pair) {
    return pair !== '';
  }).reduce(function (obj, pair) {
    var parts = pair.split('=');
    obj[decodeURIComponent(parts[0])] = null === parts[1] ? '' : decodeURIComponent(parts[1]);
    return obj;
  }, {});
};

ohauth.rawxhr = function (method, url, data, headers, callback) {
  var xhr = new XMLHttpRequest(),
      twoHundred = /^20\d$/;

  xhr.onreadystatechange = function () {
    if (4 === xhr.readyState && 0 !== xhr.status) {
      if (twoHundred.test(xhr.status)) callback(null, xhr);else return callback(xhr, null);
    }
  };

  xhr.onerror = function (e) {
    return callback(e, null);
  };

  xhr.open(method, url, true);

  for (var h in headers) {
    xhr.setRequestHeader(h, headers[h]);
  }

  xhr.send(data);
  return xhr;
};

ohauth.xhr = function (method, url, auth, data, options, callback) {
  var headers = options && options.header || {
    'Content-Type': 'application/x-www-form-urlencoded'
  };
  headers.Authorization = 'OAuth ' + ohauth.authHeader(auth);
  return ohauth.rawxhr(method, url, data, headers, callback);
};

ohauth.nonce = function () {
  for (var o = ''; o.length < 6;) {
    o += '0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz'[Math.floor(Math.random() * 61)];
  }

  return o;
};

ohauth.authHeader = function (obj) {
  return Object.keys(obj).sort().map(function (key) {
    return encodeURIComponent(key) + '="' + encodeURIComponent(obj[key]) + '"';
  }).join(', ');
};

ohauth.timestamp = function () {
  return ~~(+new Date() / 1000);
};

ohauth.percentEncode = function (s) {
  return encodeURIComponent(s).replace(/\!/g, '%21').replace(/\'/g, '%27').replace(/\*/g, '%2A').replace(/\(/g, '%28').replace(/\)/g, '%29');
};

ohauth.baseString = function (method, url, params) {
  if (params.oauth_signature) delete params.oauth_signature;
  return [method, ohauth.percentEncode(url), ohauth.percentEncode(ohauth.qsString(params))].join('&');
};

ohauth.signature = function (oauth_secret, token_secret, baseString) {
  return sha1.b64_hmac(ohauth.percentEncode(oauth_secret) + '&' + ohauth.percentEncode(token_secret), baseString);
};
/**
 * Takes an options object for configuration (consumer_key,
 * consumer_secret, version, signature_method, token, token_secret)
 * and returns a function that generates the Authorization header
 * for given data.
 *
 * The returned function takes these parameters:
 * - method: GET/POST/...
 * - uri: full URI with protocol, port, path and query string
 * - extra_params: any extra parameters (that are passed in the POST data),
 *   can be an object or a from-urlencoded string.
 *
 * Returned function returns full OAuth header with "OAuth" string in it.
 */


ohauth.headerGenerator = function (options) {
  options = options || {};
  var consumer_key = options.consumer_key || '',
      consumer_secret = options.consumer_secret || '',
      signature_method = options.signature_method || 'HMAC-SHA1',
      version = options.version || '1.0',
      token = options.token || '',
      token_secret = options.token_secret || '';
  return function (method, uri, extra_params) {
    method = method.toUpperCase();

    if (typeof extra_params === 'string' && extra_params.length > 0) {
      extra_params = ohauth.stringQs(extra_params);
    }

    var uri_parts = uri.split('?', 2),
        base_uri = uri_parts[0];
    var query_params = uri_parts.length === 2 ? ohauth.stringQs(uri_parts[1]) : {};
    var oauth_params = {
      oauth_consumer_key: consumer_key,
      oauth_signature_method: signature_method,
      oauth_version: version,
      oauth_timestamp: ohauth.timestamp(),
      oauth_nonce: ohauth.nonce()
    };
    if (token) oauth_params.oauth_token = token;
    var all_params = xtend({}, oauth_params, query_params, extra_params),
        base_str = ohauth.baseString(method, base_uri, all_params);
    oauth_params.oauth_signature = ohauth.signature(consumer_secret, token_secret, base_str);
    return 'OAuth ' + ohauth.authHeader(oauth_params);
  };
};

module.exports = ohauth;